module.exports = __webpack_public_path__ + "67f635bac5620ff22d778d60eb7b3435.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/tiers/wing-11.png
// module id = 3677
// module chunks = 0